export const FourFiveKLessons = [
  {
    lessonNumber: 1,
    lessonTitle: "My Wild Ambitions",

    PreKoreanWord1: "My",
    KoreanWord1: "국적",
    KoreanWord1EngTranslation: "nationality",
    PostKoreanWord1: "is not Korean.",

    PreKoreanWord2: "I've been thinking",
    KoreanWord2: "근래",
    KoreanWord2EngTranslation: "recently; lately",
    PostKoreanWord2: "about how best to learn Korean.",

    PreKoreanWord3: "I need to",
    KoreanWord3: "나뉘었어요",
    KoreanWord3EngTranslation: "to divide; split",
    PostKoreanWord3: "my time accordingly.",

    PreKoreanWord4: "I want to learn many",
    KoreanWord4: "낱말",
    KoreanWord4EngTranslation: "words; vocabulary items",
    PostKoreanWord4: "and phrases.",

    PreKoreanWord5: "Then I can talk to the",
    KoreanWord5: "다정하게",
    KoreanWord5EngTranslation: "kindly; warmly",
    PostKoreanWord5: "people I've met.",

    PreKoreanWord6: "During the break I'll use the",
    KoreanWord6: "냄비",
    KoreanWord6EngTranslation: "pot",
    PostKoreanWord6: "to cook.",

    PreKoreanWord7: "There will be a smell",
    KoreanWord7: "내외",
    KoreanWord7EngTranslation: "around; approximately",
    PostKoreanWord7: "the room.",

    PreKoreanWord8: "Maybe a",
    KoreanWord8: "늑대",
    KoreanWord8EngTranslation: "wolf",
    PostKoreanWord8: "might come to eat.",

    PreKoreanWord9: "They might even",
    KoreanWord9: "늘어서서",
    KoreanWord9EngTranslation: "to line up; stand in line",
    PostKoreanWord9: "outside the door!",

    PreKoreanWord10: "Hoping to enjoy a",
    KoreanWord10: "달다",
    KoreanWord10EngTranslation: "to be sweet",
    PostKoreanWord10: "dish.",

    PreKoreanWord11: "I just hope they don't",
    KoreanWord11: "달려들었어요",
    KoreanWord11EngTranslation: "to rush at; attack",
    PostKoreanWord11: "and hurt me!",

    PreKoreanWord12: "Maybe I could use",
    KoreanWord12: "망원경",
    KoreanWord12EngTranslation: "telescope",
    PostKoreanWord12: "to see them coming.",

    PreKoreanWord13: "This might serve as a good",
    KoreanWord13: "모범",
    KoreanWord13EngTranslation: "example; model",
    PostKoreanWord13: "for defending myself.",

    PreKoreanWord14: "But I should try not to",
    KoreanWord14: "무리하다",
    KoreanWord14EngTranslation: "to overdo; push oneself",
    PostKoreanWord14: "and cause a scene.",

    PreKoreanWord15: "Otherwise I'll be",
    KoreanWord15: "묶이다",
    KoreanWord15EngTranslation: "to be tied up",
    PostKoreanWord15: "for my crime.",

    PreKoreanWord16: "I just don't want to be",
    KoreanWord16: "방해하다",
    KoreanWord16EngTranslation: "to disturb; interfere",
    PostKoreanWord16: "when I'm cooking my dinner.",

    PreKoreanWord17: "This time it's wolves, last time it was a",
    KoreanWord17: "뱀",
    KoreanWord17EngTranslation: "snake",
    PostKoreanWord17: "!",

    PreKoreanWord18: "What next? A",
    KoreanWord18: "벌",
    KoreanWord18EngTranslation: "bee",
    PostKoreanWord18: "might come and sting me.",

    PreKoreanWord19: "I should really have",
    KoreanWord19: "뵈다",
    KoreanWord19EngTranslation: "to foresee; notice",
    PostKoreanWord19: "this coming a long time ago.",

    PreKoreanWord20: "It's the cost of trying to be",
    KoreanWord20: "상류",
    KoreanWord20EngTranslation: "upper class",
    PostKoreanWord20: "all the time.",

    PreKoreanWord21: "I just want my",
    KoreanWord21: "석",
    KoreanWord21EngTranslation: "seat",
    PostKoreanWord21: "at the best table.",

    PreKoreanWord22: "I have a very",
    KoreanWord22: "선명하다",
    KoreanWord22EngTranslation: "clear; distinct",
    PostKoreanWord22: "goal in this regard.",

    PreKoreanWord23: "Who wouldn't",
    KoreanWord23: "선호하다",
    KoreanWord23EngTranslation: "to prefer",
    PostKoreanWord23: "to live the good life?",

    PreKoreanWord24: "Who wouldn't want to have a",
    KoreanWord24: "성공적",
    KoreanWord24EngTranslation: "successful",
    PostKoreanWord24: "career?",

    PreKoreanWord25: "You can even get there with a",
    KoreanWord25: "소규모",
    KoreanWord25EngTranslation: "small-scale",
    PostKoreanWord25: "business if you work hard.",

    PreKoreanWord26: "Top this up with",
    KoreanWord26: "수시로",
    KoreanWord26EngTranslation: "frequently",
    PostKoreanWord26: "investing and you can't go wrong.",

    PreKoreanWord27: "But always check what's in your",
    KoreanWord27: "시야",
    KoreanWord27EngTranslation: "field of vision",
    PostKoreanWord27: "and deal with any danger.",

    PreKoreanWord28: "If your dream is going to",
    KoreanWord28: "실현되다",
    KoreanWord28EngTranslation: "to be realized",
    PostKoreanWord28: "then you need to be on guard.",

    PreKoreanWord29: "Some might say",
    KoreanWord29: "아니야",
    KoreanWord29EngTranslation: "no; it's not",
    PostKoreanWord29: "you can't get there.",

    PreKoreanWord30: "But if you try hard, then",
    KoreanWord30: "어느덧",
    KoreanWord30EngTranslation: "before you know it",
    PostKoreanWord30: "you'll be getting to where you want to be.",

    PreKoreanWord31: "Life might go",
    KoreanWord31: "오르내리다",
    KoreanWord31EngTranslation: "to go up and down",
    PostKoreanWord31: "but overall things should get better.",

    PreKoreanWord32: "You might end up living like a",
    KoreanWord32: "왕자",
    KoreanWord32EngTranslation: "prince",
    PostKoreanWord32: "!",

    PreKoreanWord33: "Surrounded by",
    KoreanWord33: "우수하다",
    KoreanWord33EngTranslation: "excellent; superior",
    PostKoreanWord33: "things.",

    PreKoreanWord34: "If you get really rich you might become",
    KoreanWord34: "유명",
    KoreanWord34EngTranslation: "famous",
    PostKoreanWord34: ".",

    PreKoreanWord35: "I really want to be that",
    KoreanWord35: "유형",
    KoreanWord35EngTranslation: "type; category",
    PostKoreanWord35: "of person.",

    PreKoreanWord36: "Sadly,",
    KoreanWord36: "으레",
    KoreanWord36EngTranslation: "usually; as a rule",
    PostKoreanWord36: "it doesn't happen this way.",

    PreKoreanWord37: "I might end up with a boring",
    KoreanWord37: "일상적",
    KoreanWord37EngTranslation: "everyday; routine",
    PostKoreanWord37: "that makes me sad.",

    PreKoreanWord38: "Where",
    KoreanWord38: "일일이",
    KoreanWord38EngTranslation: "one by one; individually",
    PostKoreanWord38: "my dreams start to die.",

    PreKoreanWord39: "I really should have",
    KoreanWord39: "전공하다",
    KoreanWord39EngTranslation: "to major in",
    PostKoreanWord39: "in finance or something.",

    PreKoreanWord40: "I thought about it",
    KoreanWord40: "전후",
    KoreanWord40EngTranslation: "before and after",
    PostKoreanWord40: "college.",

    PreKoreanWord41: "I want to get to the",
    KoreanWord41: "정상",
    KoreanWord41EngTranslation: "the top; summit",
    PostKoreanWord41: "and nothing's going to stop me.",

    PreKoreanWord42: "I've got to break free of this",
    KoreanWord42: "정상적",
    KoreanWord42EngTranslation: "normal; ordinary",
    PostKoreanWord42: "life.",

    PreKoreanWord43: "Improve my situation in",
    KoreanWord43: "질적",
    KoreanWord43EngTranslation: "qualitative",
    PostKoreanWord43: "terms.",

    PreKoreanWord44: "I'm tired of",
    KoreanWord44: "척",
    KoreanWord44EngTranslation: "pretending",
    PostKoreanWord44: "I'm happy when I'm not.",

    PreKoreanWord45: "I keep saying that next",
    KoreanWord45: "철",
    KoreanWord45EngTranslation: "season",
    PostKoreanWord45: "my luck's going to change.",

    PreKoreanWord46: "Then I just go back to",
    KoreanWord46: "청소하다",
    KoreanWord46EngTranslation: "to clean",
    PostKoreanWord46: "my mundane house.",

    PreKoreanWord47: "A",
    KoreanWord47: "충격적",
    KoreanWord47EngTranslation: "shocking",
    PostKoreanWord47: "sight for all to see.",

    PreKoreanWord48: "My",
    KoreanWord48: "치아",
    KoreanWord48EngTranslation: "teeth",
    PostKoreanWord48: "are falling out with stress.",

    PreKoreanWord49: "I need a clean",
    KoreanWord49: "판",
    KoreanWord49EngTranslation: "slate; board",
    PostKoreanWord49: "and a new start.",

    PreKoreanWord50: "That way I can live the",
    KoreanWord50: "편의",
    KoreanWord50EngTranslation: "comfortable; convenient",
    PostKoreanWord50: "life that I want.",
  },
  {
    lessonNumber: 2,
    lessonTitle: "Seoul is Changing",

    PreKoreanWord1: "They want to",
    KoreanWord1: "폐지",
    KoreanWord1EngTranslation: "abolish; remove",
    PostKoreanWord1: "this tradition, but I disagree.",

    PreKoreanWord2: "I've tried to",
    KoreanWord2: "해설",
    KoreanWord2EngTranslation: "explain; interpret",
    PostKoreanWord2: "to them over and over again.",

    PreKoreanWord3: "Many of my arguments are a little",
    KoreanWord3: "헌",
    KoreanWord3EngTranslation: "old; worn-out",
    PostKoreanWord3: "and not convincing.",

    PreKoreanWord4: "I think the situation is",
    KoreanWord4: "흑백",
    KoreanWord4EngTranslation: "black and white",
    PostKoreanWord4: "but others disagree.",

    PreKoreanWord5: "If you want something good then you'll need to",
    KoreanWord5: "희생",
    KoreanWord5EngTranslation: "sacrifice",
    PostKoreanWord5: "a lot to get it.",

    PreKoreanWord6: "All the while getting",
    KoreanWord6: "가까워지다",
    KoreanWord6EngTranslation: "to get closer",
    PostKoreanWord6: "to what you want.",

    PreKoreanWord7: "When you get there you can be",
    KoreanWord7: "감사하다",
    KoreanWord7EngTranslation: "grateful",
    PostKoreanWord7: "for all the effort you put in.",

    PreKoreanWord8: "Try to prevent a",
    KoreanWord8: "강도",
    KoreanWord8EngTranslation: "robber",
    PostKoreanWord8: "from stealing the prize.",

    PreKoreanWord9: "So get some good",
    KoreanWord9: "경비",
    KoreanWord9EngTranslation: "security; guard",
    PostKoreanWord9: "to protect it.",

    PreKoreanWord10: "Seoul is a city with great",
    KoreanWord10: "경제력",
    KoreanWord10EngTranslation: "economic power",
    PostKoreanWord10: "and culture.",

    PreKoreanWord11: "Where smoking is",
    KoreanWord11: "금하다",
    KoreanWord11EngTranslation: "to forbid",
    PostKoreanWord11: "in many public spaces.",

    PreKoreanWord12: "And you are",
    KoreanWord12: "기대되다",
    KoreanWord12EngTranslation: "expected",
    PostKoreanWord12: "to follow this rule.",

    PreKoreanWord13: "If you travel",
    KoreanWord13: "깊숙이",
    KoreanWord13EngTranslation: "deeply; far inside",
    PostKoreanWord13: "into the forest.",

    PreKoreanWord14: "You might find some",
    KoreanWord14: "꿀",
    KoreanWord14EngTranslation: "honey",
    PostKoreanWord14: "you can collect.",

    PreKoreanWord15: "But please don't",
    KoreanWord15: "넘어뜨리다",
    KoreanWord15EngTranslation: "to knock over",
    PostKoreanWord15: "the beehive!",

    PreKoreanWord16: "They've been",
    KoreanWord16: "농사짓다",
    KoreanWord16EngTranslation: "to farm; cultivate",
    PostKoreanWord16: "that honey for some time.",

    PreKoreanWord17: "Creating a",
    KoreanWord17: "단단하다",
    KoreanWord17EngTranslation: "solid; firm",
    PostKoreanWord17: "home to live in.",

    PreKoreanWord18: "With the queen being the",
    KoreanWord18: "담당자",
    KoreanWord18EngTranslation: "person in charge",
    PostKoreanWord18: "of it all.",

    PreKoreanWord19: "So hurry up and",
    KoreanWord19: "답변",
    KoreanWord19EngTranslation: "answer; reply",
    PostKoreanWord19: "when asked.",

    PreKoreanWord20: "And please be",
    KoreanWord20: "대비",
    KoreanWord20EngTranslation: "prepared",
    PostKoreanWord20: "for a negative reaction.",

    PreKoreanWord21: "You don't need to",
    KoreanWord21: "대체",
    KoreanWord21EngTranslation: "replace; substitute",
    PostKoreanWord21: "slang for formal language.",

    PreKoreanWord22: "That would be",
    KoreanWord22: "더욱더",
    KoreanWord22EngTranslation: "even more",
    PostKoreanWord22: "cumbersome for us both.",

    PreKoreanWord23: "Just walk on down to the",
    KoreanWord23: "도심",
    KoreanWord23EngTranslation: "city centre",
    PostKoreanWord23: "and have a look.",

    PreKoreanWord24: "You'll find food made from",
    KoreanWord24: "된장",
    KoreanWord24EngTranslation: "soybean paste",
    PostKoreanWord24: "and it tastes so good!",

    PreKoreanWord25: "Then look around and you'll see Seoul is",
    KoreanWord25: "둘러싸이다",
    KoreanWord25EngTranslation: "to be surrounded",
    PostKoreanWord25: "by mountains.",

    PreKoreanWord26: "You can go",
    KoreanWord26: "등산",
    KoreanWord26EngTranslation: "hiking",
    PostKoreanWord26: "whenever you want.",

    PreKoreanWord27: "Just try not to",
    KoreanWord27: "마찰",
    KoreanWord27EngTranslation: "friction; conflict",
    PostKoreanWord27: "with nature, especially the bees!",

    PreKoreanWord28: "No need to leave your",
    KoreanWord28: "마크",
    KoreanWord28EngTranslation: "mark",
    PostKoreanWord28: "on the environment.",

    PreKoreanWord29: "Have a nice walk and feel",
    KoreanWord29: "만족",
    KoreanWord29EngTranslation: "satisfaction",
    PostKoreanWord29: "at the end of it.",

    PreKoreanWord30: "Why would we want to",
    KoreanWord30: "망치다",
    KoreanWord30EngTranslation: "to ruin",
    PostKoreanWord30: "nature anyway?",

    PreKoreanWord31: "Just enjoy the food that's on the",
    KoreanWord31: "메뉴",
    KoreanWord31EngTranslation: "menu",
    PostKoreanWord31: "in the restaurant.",

    PreKoreanWord32: "Then give some money to the",
    KoreanWord32: "모금",
    KoreanWord32EngTranslation: "fundraising; donation drive",
    PostKoreanWord32: "campaign.",

    PreKoreanWord33: "They gave a long",
    KoreanWord33: "묘사",
    KoreanWord33EngTranslation: "description",
    PostKoreanWord33: "about what it was for.",

    PreKoreanWord34: "I really appreciate the",
    KoreanWord34: "문화적",
    KoreanWord34EngTranslation: "cultural",
    PostKoreanWord34: "side of this city.",

    PreKoreanWord35: "Even if some of it is",
    KoreanWord35: "묻히다",
    KoreanWord35EngTranslation: "to be buried; covered",
    PostKoreanWord35: "under modernity.",

    PreKoreanWord36: "More and more people are",
    KoreanWord36: "미혼",
    KoreanWord36EngTranslation: "unmarried",
    PostKoreanWord36: "as they get older.",

    PreKoreanWord37: "Korea has",
    KoreanWord37: "발전되다",
    KoreanWord37EngTranslation: "to be developed",
    PostKoreanWord37: "so much and this is what happens.",

    PreKoreanWord38: "I watched a report that the",
    KoreanWord38: "방송사",
    KoreanWord38EngTranslation: "broadcasting company",
    PostKoreanWord38: "created.",

    PreKoreanWord39: "We're going to have to take steps to",
    KoreanWord39: "방지하다",
    KoreanWord39EngTranslation: "to prevent",
    PostKoreanWord39: "problems arising from it.",

    PreKoreanWord40: "Some politicians even gave in a",
    KoreanWord40: "사표",
    KoreanWord40EngTranslation: "resignation",
    PostKoreanWord40: "because they couldn't solve the problem.",

    PreKoreanWord41: "But we should",
    KoreanWord41: "삼가다",
    KoreanWord41EngTranslation: "to refrain; avoid",
    PostKoreanWord41: "from blaming anyone.",

    PreKoreanWord42: "At least that's what they said during the",
    KoreanWord42: "생방송",
    KoreanWord42EngTranslation: "live broadcast",
    PostKoreanWord42: "on the topic.",

    PreKoreanWord43: "It was the",
    KoreanWord43: "셋째",
    KoreanWord43EngTranslation: "third",
    PostKoreanWord43: "time I'd seen something about it.",

    PreKoreanWord44: "There's no room to be",
    KoreanWord44: "소홀히",
    KoreanWord44EngTranslation: "careless; negligent",
    PostKoreanWord44: "in our old age.",

    PreKoreanWord45: "Look after your",
    KoreanWord45: "손발",
    KoreanWord45EngTranslation: "hands and feet",
    PostKoreanWord45: "otherwise you're in trouble.",

    PreKoreanWord46: "If you're",
    KoreanWord46: "쌍둥이",
    KoreanWord46EngTranslation: "twins",
    PostKoreanWord46: "then look after each other.",

    PreKoreanWord47: "Try your best to",
    KoreanWord47: "안내하다",
    KoreanWord47EngTranslation: "to guide",
    PostKoreanWord47: "people in the right direction.",

    PreKoreanWord48: "Then find a place to",
    KoreanWord48: "앉히다",
    KoreanWord48EngTranslation: "to seat someone",
    PostKoreanWord48: "and relax.",

    PreKoreanWord49: "Unless it's",
    KoreanWord49: "영하",
    KoreanWord49EngTranslation: "below zero (temperature)",
    PostKoreanWord49: "then go and find somewhere warm.",

    PreKoreanWord50: "You don't want to get kicked in the",
    KoreanWord50: "옆구리",
    KoreanWord50EngTranslation: "side; ribs",
    PostKoreanWord50: "by the cold!",
  },
];
